import { Paginator } from '@onwardtravelsolutions/package-react/Types';
import { NumberedPaginator, PaginationSummary, SimplePaginator } from '.';

type SimplePaginatorProps = {
    paginator: Paginator;
    className?: string;
    isSimple?: boolean;
};

export default function PaginationToolbar({
    paginator,
    isSimple = false,
    className = '',
}: SimplePaginatorProps) {
    return (
        <>
            {paginator.isPaginatable && (
                <div
                    className={`flex flex-col justify-center w-full gap-4 text-center md:flex-row md:items-center md:justify-between ${className}`}
                >
                    <PaginationSummary paginator={paginator} />
                    {isSimple ? (
                        <div className='w-full md:max-w-50'>
                            <SimplePaginator paginator={paginator} />
                        </div>
                    ) : (
                        <NumberedPaginator paginator={paginator} />
                    )}
                </div>
            )}
        </>
    );
}
